export default __webpack_public_path__ + "static/media/Lexus.a0fa7ae3.jpg";